export default {
  slug: 'ws-footer-navigation',
  triggerId: 'footer-navigation',
};
